// components/sessions/MeetingsTab.js
import React from 'react';
import SessionsTab from './SessionsTab';

const MeetingsTab = (props) => {
  const meetingConfig = {
    title: 'I miei Meeting',
    emptyMessage: 'Non hai ancora nessun meeting. Programma il tuo primo meeting!',
    primaryAction: 'Nuovo Meeting',
    filters: {
      showLeaderDrive: true,
      showSecretary: true,
      defaultTimeRange: 'month'
    }
  };
  
  return (
    <SessionsTab 
      {...props} 
      sessionType="meeting"
      tabConfig={meetingConfig}
    />
  );
};

export default MeetingsTab;